(ns assemble.assets-page.view
  (:require ["@mui/material/Stack$default" :as Stack]
            [assemble.assets-page.drawer.assets :as assets-drawer]
            [assemble.assets-page.drawer.folders :as folders-drawer]
            [assemble.assets-page.drawer.fonts :as fonts-drawer]
            [assemble.assets-page.file-grid.view :refer [file-grid]]
            [assemble.assets-page.upload-modal.db]
            [assemble.assets-page.upload-modal.view :refer [new-asset-modal]]
            [assemble.component.file-tree.hooks :refer [use-active-asset-type]]
            [assemble.component.move-modal.db :as move-modal.db]
            [assemble.component.move-modal.view :refer [move-modal]]
            [assemble.component.new-folder :refer [new-folder-modal] :as new-folder]
            [assemble.component.upload :as upload]
            [assemble.sidebar :refer [sidebar-content]]
            [assemble.util :as util]
            [common.util :refer [spread-obj]]
            [common.widgets.page :as page]
            [linked.core :as l]
            [re-frame.core :as rf]
            [uix.core :as uix :refer [$ defui]]
            [uix.re-frame :refer [use-subscribe]]))

(defui asset-buttons [{:keys [asset-type]}]
  ($ :<>
     (when (not= :fonts asset-type)
       ($ new-folder/new-folder-button))
     ($ upload/upload-button
        {:on-click #(rf/dispatch [:assemble.assets-page.upload-modal.db/open {:files nil :asset-type asset-type}])})))

(defui assets-content []
  (let [asset-type (use-active-asset-type)
        font-family (use-subscribe [:assemble.page.assets.file-tree/font-family])]
    ($ Stack
       {:direction "row"
        :flex 1
        :sx #js {:overflow "hidden"}}
       ($ file-grid)
       (case asset-type
         :assets ($ assets-drawer/assets-drawer)
         :fonts (if font-family
                  ($ fonts-drawer/font-family-drawer {:font-family font-family})
                  ($ fonts-drawer/fonts-drawer))
         :logos ($ assets-drawer/assets-drawer)
         nil)
       ($ folders-drawer/folders-drawer))))

(defn tabs [fonts-folder logos-folder]
  (l/map :fonts
         {:label "Fonts"
          :on-click (fn [_e] (rf/dispatch [:assemble.page.assets.file-tree/set-current-node fonts-folder]))
          :view assets-content}
         :logos
         {:label "Logos"
          :on-click (fn [_e] (rf/dispatch [:assemble.page.assets.file-tree/set-current-node logos-folder]))
          :view assets-content}))

(defui assets-page []
  (let [{:keys [sub-title]} (use-subscribe [:router/route-data])
        ;; Request new folders and nodes when switching advertiser
        {:keys [advertiser-id]} (use-subscribe [:url-context])
        root-folder (:value (use-subscribe [:cqrs/get :asset/list-folders]))
        type->folders (into {} (map (fn [{:keys [asset-tree/folder-type] :as x}]
                                      [folder-type x])
                                    (:children root-folder)))
        fonts-folder (:asset-tree/id (get type->folders "fonts"))
        logos-folder (:asset-tree/id (get type->folders "logos"))
        node-id (use-subscribe [:assemble.page.assets.file-tree/current-node-id])
        asset-type (use-active-asset-type)
        os-enabled? (use-subscribe [:common.os/enabled])]
    ;; Request new assets list when the selected node changes
    (uix/use-effect (fn []
                      (when node-id
                        (rf/dispatch [:assemble.resource.asset/list-assets-for-node node-id])
                        (rf/dispatch [:assemble.resource.asset/list-font-families-for-advertiser])))
                    [advertiser-id node-id])
    (util/use-keyboard-listener
     {;; FIXME: Disable new-folder shortcut for fonts view
      #{"Shift" "Meta" "."} #(rf/dispatch [::new-folder/open-new-folder-modal])
      #{"Shift" "Meta" ","} #(rf/dispatch [:assemble.assets-page.upload-modal.db/open {:files nil :asset-type asset-type}])
      #{"Escape"} #(rf/dispatch [:assemble.assets-page/drawer-close])})
    ($ :<>
       ;; MUI dialog can be placed anywhere on the React tree.
       ;; It is easiest to have it next to the page where it is used.
       ($ new-asset-modal)
       ($ new-folder-modal)
       ($ move-modal
          {:on-submit-event [::move-modal.db/check-for-folder-submit-event]
           :type :asset})
       ($ page/page
          {:title "Assemble - Asset Library"
           :sx #js {:backgroundColor "white"
                    :marginLeft 3
                    :borderRadius 2}
           :content-sx (spread-obj #js {:py 3}
                                   (if os-enabled?
                                     page/wpp-os-content-padding-sx
                                     page/content-padding-sx))
           :page-sx #js {:backgroundColor "grey.90"}
           :sidebar-sx #js {:borderRadius 2
                            :borderRight 0
                            :overflow "hidden"}
           :sidebar-toggle? false
           :sidebar-content ($ sidebar-content
                               {:type asset-type})}
          ($ page/page-header
             (merge {:title sub-title
                     :buttons ($ asset-buttons {:asset-type asset-type})}
                    (when (and asset-type (not= asset-type :assets))
                      {:tabs (tabs fonts-folder logos-folder)})))

          (if (and asset-type (not= asset-type :assets))
            ($ page/active-tab
               {:tabs (tabs fonts-folder logos-folder)
                :sx #js {:overflow "hidden"}})
            ($ assets-content))))))
